import { canonicalPath } from "@/utils/canonicalPath";

// TD-146 requires market, page_type and source_page on every event, GA4 and
// Meta alike. TD-126 seeds market/page_type into the dataLayer for GTM; read
// them back here so both pipes stamp the same dimensions rather than each
// inventing their own.
export const getEventContext = (): Record<string, string> => {
    if (typeof window === "undefined") return {};

    const context: Record<string, string> = {};

    const layer = (window as any).dataLayer;
    if (Array.isArray(layer)) {
        // Last write wins: a client-side navigation reseeds these, and the
        // event belongs to whichever page the visitor is on now.
        for (const entry of layer) {
            if (!entry || typeof entry !== "object") continue;
            if (typeof entry.market === "string") context.market = entry.market;
            if (typeof entry.page_type === "string") {
                context.page_type = entry.page_type;
            }
        }
    }

    if (typeof location !== "undefined") {
        // Canonicalised for the same reason as TD-127 — otherwise the same page
        // arrives under two source_page values depending on how it was reached.
        context.source_page = canonicalPath(location.pathname);
    }

    return context;
};
